import { Injectable } from '@angular/core';
import { BaseDAO } from './baseDAO';
import { ConstantMan } from '../constantMan';
import { ApiHelper } from '../apiHelper';
import { Observable } from 'rxjs';
import { HttpHeaders } from '@angular/common/http';
import { VesselAvailabilityPreferences } from 'anchor-shared/lib/model/entity/vesselAvailabilityPreferences';
import { BuyflowProductOffering } from 'anchor-shared/lib/model/interface/buyflowProductOffering';
import { Moment } from 'moment';
import { ProductConflict } from 'anchor-shared/lib/model/interface/productConflict';

@Injectable()
export class VesselAvailabilityPreferencesDAO extends BaseDAO<VesselAvailabilityPreferences> {
  constructor(public readonly apiHelper: ApiHelper) {
    super(apiHelper, ConstantMan.API.RESOURCE.VESSEL_AVAILABILITY_PREFERENCES);
  }

  public createNewPreferences(
    partialVesselPreferences: Partial<VesselAvailabilityPreferences>,
  ): Observable<any> {
    let url: string =
      this.apiHelper.getServiceName() +
      this.getResource() +
      '/' +
      partialVesselPreferences.vesselId;
    const method = 'POST';
    const headers: HttpHeaders = this.apiHelper.getDefaultHeader();
    return this.apiHelper.apiCall<any[]>(
      url,
      method,
      null,
      partialVesselPreferences,
      headers,
    );
  }

  public update(
    vesselId: number,
    vesselPrefsId: number,
    partialVesselPreferences: Partial<VesselAvailabilityPreferences>,
  ): Observable<any> {
    let url: string =
      this.apiHelper.getServiceName() +
      this.getResource() +
      '/vessel/' +
      vesselId +
      '/vessel-prefs/' +
      vesselPrefsId;
    const method = 'PUT';
    const headers: HttpHeaders = this.apiHelper.getDefaultHeader();
    return this.apiHelper.apiCall<any[]>(
      url,
      method,
      null,
      partialVesselPreferences,
      headers,
    );
  }

  public charterHasProductConflicts(
    vesselId: number,
    conflictRequest: CharterConflictRequest,
  ): Observable<ProductConflict[]> {
    let url: string =
      this.apiHelper.getServiceName() +
      this.getResource() +
      '/vessel/' +
      vesselId +
      '/has-product-conflicts';
    const method = 'POST';
    const headers: HttpHeaders = this.apiHelper.getDefaultHeader();
    return this.apiHelper.apiCall<ProductConflict[]>(
      url,
      method,
      null,
      conflictRequest,
      headers,
    );
  }

  public findByVesselId(
    vesselId: number,
  ): Observable<VesselAvailabilityPreferences> {
    let url: string =
      this.apiHelper.getServiceName() +
      this.getResource() +
      '/vessel/' +
      vesselId;
    const method = 'GET';
    const headers: HttpHeaders = this.apiHelper.getDefaultHeader();
    return this.apiHelper.apiCall<VesselAvailabilityPreferences>(
      url,
      method,
      null,
      null,
      headers,
    );
  }
  public getAvailableProductsForDay(
    vesselId: number,
    availableOn: Moment,
  ): Observable<BuyflowProductOffering[]> {
    const url: string =
      this.apiHelper.getServiceName() +
      this.getResource() +
      `/get-products/${vesselId}/${availableOn.format('x')}`;
    const method = 'GET';
    const headers: HttpHeaders = this.apiHelper.getDefaultHeader();
    return this.apiHelper.apiCall<BuyflowProductOffering[]>(
      url,
      method,
      null,
      null,
      headers,
    );
  }
}

export interface CharterConflictRequest {
  date: string;
  toDate?: string;
  vesselId: number;
  startTime: string;
  endTime: string;
}
